import { printLine } from "./utilities.js";

export class BaseError extends Error {
  constructor(message) {
    super(message);
    this.name = "BaseError";
  }

  async handleError() {
    await printLine();
    await printLine(`?${this.name}  ERROR`);
  }
}

export class SyntaxErrorProgram {
  constructor(message, lineNumber) {
    this.message = message;
    this.lineNumber = lineNumber;
  }

  async handleError() {
    await printLine();
    await printLine(`?SYNTAX  ERROR IN ${this.lineNumber}`);
  }
}

export class SyntaxError extends BaseError {
  constructor(message) {
    super(message);
    this.name = "SYNTAX";
  }
}

export class UndefinedError extends BaseError {
  constructor(message) {
    super(message);
    this.name = "UNDEF'D STATEMENT";
  }
}

export class DeviceNotPresentError extends BaseError {
  constructor(message) {
    super(message);
    this.name = "DEVICE NOT PRESENT";
  }
}

export class TypeMismatchError extends BaseError {
  constructor(message) {
    super(message);
    this.name = "TYPE MISMATCH";
  }
}

export class MissingFileNameError extends BaseError {
  constructor(message) {
    super(message);
    this.name = "MISSING FILE NAME";
  }
}

export class OverflowError extends BaseError {
  constructor(message) {
    super(message);
    this.name = "OVERFLOW";
  }
}

export class DivisionByZeroError extends BaseError {
  constructor(message) {
    super(message);
    this.name = "DIVISION BY ZERO";
  }
}

export class IllegalQuantityError extends BaseError {
  constructor(message) {
    super(message);
    this.name = "ILLEGAL QUANTITY";
  }
}

export class StringTooLongError extends BaseError {
  constructor(message) {
    super(message);
    this.name = "STRING TOO LONG";
  }
}